import { createAction } from 'redux-actions';

export const setListsByUser = createAction('SET_LISTS_BY_USER');
export const setFeaturedLists = createAction('SET_FEATURED_LISTS');
export const setLatestLists = createAction('SET_LATEST_LISTS');